import { zodResolver } from '@hookform/resolvers/zod';
import { Group, Stack } from '@mantine/core';
import { FormProvider, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { PublisherTypeSelectControl } from '@/module/Nomen/PublisherType/PublisherTypeSelectControl';
import { PeerReviewSelectControl } from '@/module/Publisher/components/form/PeerReviewSelectControl';
import { PrestigeSelectControl } from '@/module/Publisher/components/form/PrestigeSelectControl';

import { Content, Form, FormSubmit, TextInputControl } from '@/core/components';

import { PublisherSchema } from './model/PublisherSchema';

interface PublisherFormProps extends FormSubmit<PublisherSchema> {
  title: string;
}

export function PublisherForm(props: PublisherFormProps) {
  const { title, schema, defaultValues, values, isSubmitting, onCancel, onSubmit } = props;
  const { t } = useTranslation();
  const form = useForm<PublisherSchema>({
    defaultValues,
    values,
    resolver: zodResolver(schema),
  });

  return (
    <FormProvider {...form}>
      <Form
        title={title}
        isSubmitting={isSubmitting}
        onCancel={onCancel}
        onSubmit={form.handleSubmit(onSubmit)}
      >
        <Stack>
          <Content type="full">
            <TextInputControl<PublisherSchema>
              name="title"
              label={t('publishers.form.fields.title')}
              isSubmitting={isSubmitting}
            />
            <TextInputControl<PublisherSchema>
              name="address"
              label={t('publishers.form.fields.address')}
              isSubmitting={isSubmitting}
            />
            <PublisherTypeSelectControl<PublisherSchema>
              label={t('publishers.form.fields.type')}
              name="type"
              isSubmitting={isSubmitting}
            />
            <Group>
              <PeerReviewSelectControl<PublisherSchema>
                label={t('publishers.form.fields.peerReview')}
                name="peerReview"
                isSubmitting={isSubmitting}
              />
              <PrestigeSelectControl<PublisherSchema>
                label={t('publishers.form.fields.prestige')}
                name="prestige"
                isSubmitting={isSubmitting}
              />
            </Group>
          </Content>
        </Stack>
      </Form>
    </FormProvider>
  );
}
